/* eslint-disable import/default */
import 'babel-polyfill';
import 'isomorphic-fetch';
import './scss/common.scss';
import './favicon.ico';
import './img/350x200_Pinstar_Thmnl.jpg';
import './img/bowler.png';
import './img/usbc-banner.png';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import Router from 'react-router/lib/Router';
import browserHistory from 'react-router/lib/browserHistory';
import {syncHistoryWithStore} from 'react-router-redux';
import routes from './routes';
import store from './store';
import {handleRouterUpdate} from 'shared/actions';
import ReactGA from 'react-ga';
import {GOOGLE_ANALYTICS_TRACKING_ID} from 'shared/variables';
import {FACEBOOK_PIXEL_ID} from 'shared/variables';
import ReactPixel from 'react-facebook-pixel';

//Unique Google Analytics tracking number
ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

ReactPixel.init(FACEBOOK_PIXEL_ID);

ReactPixel.pageView(); // For tracking page view

render(
  <Provider store={store}>
    <Router
      history={history}
      routes={routes}
      onUpdate={() => store.dispatch(handleRouterUpdate())}
    />
  </Provider>, document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js